<template>
  <div>
    <Filtro @filtro="makeFiltro"></Filtro>

    <List
      :filtro="filtro"
      :subjectPermission="subjectPermission"
      ref="list"
    ></List>
  </div>
</template>

<script>
import Filtro from './components/FiltroEventos';
import List from './components/ListEventos';

export default {
  data() {
    return {
      filtro: null,
      subjectPermission: 'Eventos',
    };
  },
  methods: {
    makeFiltro(filtro) {
      this.filtro = filtro;

      this.$nextTick(() => {
        this.$refs.list.buscaDados();
      });
    },
  },
  components: {
    Filtro,
    List,
  },
};
</script>
